import { dumpsterRentalDataFr } from "constants-lib/seo/dumpsterRentalData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getDumpsterRentalFr = () => {
  const data = dumpsterRentalDataFr.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addDumpsterRental = () => {
  if (
    window.location.pathname === `/ca/fr/dumpster-rental/` &&
    document.getElementById(`dumpsterRentalJSONLD`) === null
  ) {
    const script = dumpsterRentalJSONLDFr()
    addJSONLDToHead(script, `dumpsterRentalJSONLD`)
  } else {
    removeElement(`dumpsterRentalJSONLD`)
  }
}

const dumpsterRentalJSONLDFr = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getDumpsterRentalFr(),
  }
  return FaqBagsterTemplate
}
